// based on UserRoles: features/issue/src/models/user-roles.ts
export type IssuePermissions =
  | 'isIssueTypeManager'
  | 'isApprover'
  | 'isManager'
  | 'isCreator'
  | 'isOwner'
  | 'isActionOwner'
  | 'isActionApprover';

export enum IssuePermissionsEnum {
  IsIssueTypeManager = 'isIssueTypeManager',
  IsApprover = 'isApprover',
  IsManager = 'isManager',
  IsCreator = 'isCreator',
  IsOwner = 'isOwner',
  IsActionOwner = 'isActionOwner',
  IsActionApprover = 'isActionApprover',
}
